import React, { useState } from 'react';
import ColorCheckbox from '../../atoms/ColorCheckbox';
import NCPListFilterQuery from 'ui/helpers/utils/NCPListFilterQuery';
import { encode } from 'querystring';
import { useRouter } from '../../../hooks/useCustomRouter';
import { IRootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import eventClickNCL from '../../../helpers/emarsys/new-car-list/eventClickNCL';
import { BUTTON_NAME_NEW_CAR_LIST } from '../../../constants/emarsys/new-car-list';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';

export interface FilterColorProps {
  colorList: {
    name: string;
    query: {
      url: string;
    };
    selected: boolean;
  }[];
  impressionData?: {
    customerNo?: string;
    title?: string;
    carCategory?: string;
    carModel?: string;
    sectionName?: string;
    filterValue?: {
      price?: string;
      search?: string;
      color?: string;
      fuel_type?: string;
      transmission?: string;
      capacity?: string;
      tag?: string;
      order_by?: string;
    };
  };
  breadcrumbItems?: IBreadcrumbs[];
}

export default function FilterColor({
  colorList,
  impressionData,
  breadcrumbItems,
}: FilterColorProps) {
  const router = useRouter();
  const [dataCheckbox, setDataCheckbox] = useState<string[]>([]);
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    const cleanedQuery = NCPListFilterQuery(value);
    const existingQueryParams = router.query;
    if (existingQueryParams?.q) {
      delete existingQueryParams.q;
    }
    const newUrl = `${new URLSearchParams(
      existingQueryParams ? encode(existingQueryParams) : ''
    ).toString()}`;

    const colorListTemp = colorList
      ?.filter((item) => item?.selected)
      ?.map((item) => {
        return item.name;
      });
    const valueCode = colorList?.find((item) => {
      const val = item?.query?.url.replace(/%3AbodyType%3A\w+/gi, '');
      return val.replace('/c/mobil-baru-toyota', router.pathname) === value;
    })?.name;
    eventClickNCL(
      dispatch,
      userData?.customerNo || '',
      impressionData?.title || '',
      impressionData?.carCategory || '',
      '',
      impressionData?.sectionName || '',
      BUTTON_NAME_NEW_CAR_LIST.WARNA,
      breadcrumbItems,
      {
        ...impressionData.filterValue,
        color: checked
          ? [...colorListTemp, valueCode].join(',')
          : colorListTemp.filter((e) => e !== valueCode).join(','),
      }
    );

    if (newUrl === '') {
      router.push(cleanedQuery);
    } else {
      router.push(cleanedQuery + `&` + newUrl);
    }

    if (checked) {
      setDataCheckbox([...dataCheckbox, value]);
    } else {
      setDataCheckbox(dataCheckbox.filter((e) => e !== value));
    }
  };

  return (
    <div>
      {colorList.map((item, _i) => {
        //remove bodytype query
        const val = item?.query?.url.replace(/%3AbodyType%3A\w+/gi, '');
        return (
          <ColorCheckbox
            key={_i}
            label={item?.name}
            value={val.replace('/c/mobil-baru-toyota', router.pathname)}
            onChange={handleFilterChange}
            checked={item?.selected}
          />
        );
      })}
    </div>
  );
}
